var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card",
    attrs: {
      "data-testid": "calendar-page"
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-inline"
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("Kalendář")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctorId),
      expression: "doctorId"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora",
      "data-testid": "calendar-doctor"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.doctorId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2)])]), _vm._v(" "), (_vm.doctorId) ? _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-outline-primary",
    attrs: {
      "type": "button",
      "data-testid": "calendar-edit-leisure"
    },
    on: {
      "click": _vm.showModalCalendarLeisureTime
    }
  }, [_c('i', {
    staticClass: "fa fa-smile-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upravit volno")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-outline-primary",
    attrs: {
      "type": "button",
      "data-testid": "calendar-edit-working-time"
    },
    on: {
      "click": _vm.showModalCalendarWorkingTime
    }
  }, [_c('i', {
    staticClass: "fa fa-suitcase",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Upravit pracovní dobu")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "calendar-previous-week"
    },
    on: {
      "click": function($event) {
        _vm.previousPeriod()
      }
    }
  }, [_vm._v("Předchozí týden")])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "mr-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "data-testid": "calendar-current-week"
    },
    on: {
      "click": _vm.actualPeriod
    }
  }, [_vm._v("Aktuální týden")])]), _vm._v(" "), _c('div', {}, [_c('datepicker', {
    attrs: {
      "placeholder": "vybrat datum",
      "format": "dd.MM.yyyy",
      "language": "cs",
      "monday-first": true,
      "full-month-name": true,
      "name": "chooseDate",
      "input-class": "datapickerInput",
      "data-testid": "calendar-date"
    },
    on: {
      "input": function($event) {
        _vm.manualSelectDate($event)
      }
    },
    model: {
      value: (_vm.selectedDate),
      callback: function($$v) {
        _vm.selectedDate = $$v
      },
      expression: "selectedDate"
    }
  })], 1)]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-testid": "calendar-next-week"
    },
    on: {
      "click": function($event) {
        _vm.nextPeriod()
      }
    }
  }, [_vm._v("Následující týden")])])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "h4",
    attrs: {
      "data-testid": "calendar-week-range"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.get_params.from) + " - " + _vm._s(_vm.get_params.to) + " (" + _vm._s((_vm.moment(this.start_date).isoWeek()) % 2 === 1 ? 'lichý' : 'sudý') + ")\n            ")]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "div_table"
  }, [_c('table', {
    staticClass: "table table_calendar",
    attrs: {
      "data-testid": "calendar-grid"
    }
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / _vm.windowsPerHour)), function(times, index) {
    return _c('th', {
      attrs: {
        "colspan": _vm.windowsPerHour
      }
    }, [_vm._v("\n                        " + _vm._s((index + _vm.startHour) < 10 ? '0' + (index + _vm.startHour) : (index + _vm.startHour)) + "\n                    ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / (_vm.windowsPerHour / 2))), function(times, index) {
    return _c('th', {
      staticClass: "halfHour",
      attrs: {
        "colspan": (_vm.windowsPerHour / 2)
      }
    }, [_vm._v("\n                         \n                    ")])
  })], 2), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.calendar !== false) ? _c('tbody', {
    staticStyle: {
      "line-height": "1.2"
    }
  }, [_vm._l((7), function(n) {
    return [_c('tr', [_c('td', {
      attrs: {
        "data-testid": 'calendar-day-' + _vm.moment(_vm.render_start_date).add(n - 1, 'days').format('YYYY-MM-DD')
      },
      on: {
        "click": function($event) {
          _vm.getVisitsForDay(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L'))
        }
      }
    }, [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ({
            content: _vm.calendar[n - 1][cell + _vm.startWindow - 1]['visit'].length > 0 ? _vm.windowsHoverVisits(_vm.calendar[n - 1][cell + _vm.startWindow - 1]['visit']) : '',
            placement: 'bottom-center',
            classes: ['info']
          }),
          expression: "{\n                              content: calendar[n-1][cell + startWindow - 1]['visit'].length > 0 ? windowsHoverVisits(calendar[n-1][cell + startWindow - 1]['visit']) : '',\n                              placement: 'bottom-center',\n                              classes: ['info']}"
        }],
        class: _vm.getRightClassForTd(_vm.calendar[n - 1][cell + _vm.startWindow - 1]) + ' ' + ((cell % _vm.windowsPerHour === 0) ? 'hourly' : '') + ' ' + ((cell % _vm.windowsPerHour === _vm.windowsPerHour / 2) ? 'halfhourly' : ''),
        attrs: {
          "data-window-id": (n - 1) + '_' + (_vm.startWindow + cell - 1),
          "data-testid": 'calendar-cell-' + (n - 1) + '-' + (_vm.startWindow + cell - 1)
        },
        on: {
          "click": function($event) {
            _vm.getVisitsForWindow(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L'), _vm.startWindow + cell - 1)
          }
        }
      }, [_vm._v("\n                       \n                      "), _vm._l((_vm.calendar[n - 1][cell + _vm.startWindow - 1]['visit']), function(visit) {
        return [_c('div', {
          staticStyle: {
            "position": "relative"
          }
        }, [_c('div', {
          staticClass: "visit_slot",
          staticStyle: {
            "position": "absolute"
          },
          style: ({
            backgroundColor: '#' + visit.visit_purpose.color,
            top: visit.row_slot_number * 6 + 'px'
          }),
          attrs: {
            "title": _vm.visitSlotHover(visit),
            "data-testid": 'calendar-visit-strip-' + visit.id
          }
        })])]
      })], 2)
    })], 2), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return [(_vm.calendar[n - 1][cell + _vm.startWindow - 1]['skipNote'] === 0 || _vm.calendar[n - 1][cell + _vm.startWindow - 1]['type'] !== 'work') ? _c('td', {
        staticStyle: {
          "position": "relative"
        },
        attrs: {
          "colspan": _vm.calendar[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.calendar[n - 1][cell + _vm.startWindow - 1]['note']['windowsCount'] : 1
        }
      }, [_c('div', {
        staticStyle: {
          "position": "absolute",
          "overflow": "hidden",
          "text-overflow": "ellipsis",
          "width": "100%",
          "text-align": "center"
        }
      }, [_vm._v("\n                          " + _vm._s(_vm.calendar[n - 1][cell + _vm.startWindow - 1]['note'] ? _vm.calendar[n - 1][cell + _vm.startWindow - 1]['note']['text'] : '') + "\n                        ")])]) : _vm._e()]
    })], 2)]
  })], 2) : _c('tbody', _vm._l((7), function(n) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.moment(_vm.render_start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        staticClass: "blank_windows"
      }, [_vm._v("\n                             \n                        ")])
    })], 2)
  }))]), _vm._v(" "), (_vm.calendar === false || _vm.calendarPending === true) ? _c('div', {
    staticClass: "table_overlay"
  }, [(_vm.calendarPending === true) ? _c('div', {}, [_vm._m(1), _vm._v(" "), _vm._m(2)]) : (_vm.calendar === false) ? _c('div', {
    staticClass: "text-danger"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4)]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), (_vm.visits.length > 0) ? _c('div', {
    staticClass: "card-body",
    attrs: {
      "data-testid": "calendar-visits"
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', [_vm._l(((_vm.visits)), function(visit, index) {
    return [_c('tr', {
      attrs: {
        "data-testid": 'calendar-visit-' + visit.id
      }
    }, [_c('td', {
      staticClass: "align-middle",
      attrs: {
        "rowspan": "2"
      }
    }, [(visit.state === 'scheduled') ? _c('i', {
      staticClass: "fa fa-2x fa-circle-o text-info",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'arrived') ? _c('i', {
      staticClass: "fa fa-2x fa-clock-o text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'completed') ? _c('i', {
      staticClass: "fa fa-2x fa-check-circle text-success",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'elaborated') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'failed') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'excused') ? _c('i', {
      staticClass: "fa fa-2x fa-dot-circle-o text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : (visit.state === 'canceled') ? _c('i', {
      staticClass: "fa fa-2x fa-times-circle text-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "align-middle"
    }, [(visit.hasData) ? [_c('button', {
      staticClass: "btn btn-sm btn_extra_small btn-primary",
      on: {
        "click": function($event) {
          _vm.showHideVisitDetail(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })])] : _vm._e(), _vm._v("\n                        " + _vm._s(visit.date) + " od " + _vm._s(visit.timeFrom) + " do " + _vm._s(visit.timeTo) + " (" + _vm._s(_vm._f("minutesToCsTime")(visit.duration * 5)) + ")\n                    ")], 2), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "align-middle",
      attrs: {
        "colspan": "2"
      }
    }, [_c('b', [_vm._v(_vm._s(visit.visit_purpose.purpose))]), _vm._v(" "), (_vm.editingVisitId === visit.id) ? [_c('label', {
      attrs: {
        "for": "note"
      }
    }, [_vm._v("poznámka: ")]), _vm._v(" "), _c('form', {
      staticClass: "form-inline",
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.putVisit(visit)
        }
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editingVisit.note),
        expression: "editingVisit.note"
      }],
      staticClass: "form-control ml-sm-1 mr-sm-2",
      attrs: {
        "type": "text",
        "aria-describedby": "noteHelp",
        "id": "note"
      },
      domProps: {
        "value": (_vm.editingVisit.note)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editingVisit.note = $event.target.value
        }
      }
    }), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Uložit")]) : _c('button', {
      staticClass: "btn btn-primary disabled",
      attrs: {
        "disabled": "disabled"
      }
    }, [_c('i', {
      staticClass: "fa fa-spinner fa-pulse fa-fw"
    }), _vm._v(" Ukládám")])])] : [_c('button', {
      staticClass: "btn btn-sm btn-link text-secondary",
      attrs: {
        "data-testid": 'calendar-visit-edit-' + visit.id
      },
      on: {
        "click": function($event) {
          _vm.editVisit(visit.note, visit.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('i', [_vm._v("poznámka: " + _vm._s(visit.note))])]], 2)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "border-top-0",
      attrs: {
        "colspan": "3"
      }
    }, [_c('router-link', {
      staticClass: "text-secondary",
      attrs: {
        "to": {
          name: 'ShowClient',
          params: {
            clientid: visit.client.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-address-card-o",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('b', [_vm._v(_vm._s(visit.client.first_name) + " " + _vm._s(visit.client.last_name))]), _vm._v(" - "), _c('b', [_vm._v(_vm._s(visit.client.p_i_n))]), _vm._v(" "), (visit.client.health_insurance) ? _c('span', {
      staticClass: "badge badge-secondary"
    }, [_vm._v(_vm._s(visit.client.health_insurance.code))]) : _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybí zdrav. pojišťovna")]), _vm._v(" "), (visit.client.membership) ? _c('span', {
      staticClass: "badge badge-primary"
    }, [_vm._v(_vm._s(visit.client.membership.name))]) : _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-warning",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" nemá program")]), _vm._v(" "), (visit.client.missing_data) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící údaje")]) : _vm._e(), _vm._v(" "), (visit.client.missing_contact) ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_c('i', {
      staticClass: "fa fa-danger",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(" chybějící kontakty")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
      staticClass: "border-top-0 text-right",
      attrs: {
        "colspan": "1"
      }
    }, [_vm._v("\n                        " + _vm._s(visit.planned_for.fullname) + "\n                        ")])]), _vm._v(" "), (_vm.showedVisitDetail.indexOf(index) > -1) ? _c('tr', [_c('td', {
      staticClass: "border-top-0"
    }), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [(visit.presenting_complaint) ? _c('div', {
      staticClass: "row m-0"
    }, [_c('h6', [_vm._v(_vm._s(visit.presenting_complaint.anamnesis_type.name))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.presenting_complaint.text)
      }
    })]) : (visit.medical_report) ? _c('div', {}, [_c('h6', [_vm._v("Výsledná zpráva")]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(visit.medical_report.text)
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {}, [_c('h6', [_vm._v("Diagnózy a výkony")]), _vm._v(" "), _c('div', [_c('table', {
      staticClass: "table"
    }, [_c('tbody', [_vm._l((visit.diagnosis), function(diagnose) {
      return [_c('tr', [_c('td', [_vm._v(_vm._s(diagnose.disease.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(diagnose.disease.name_cs))])]), _vm._v(" "), (diagnose.actions.length > 0) ? _vm._l((diagnose.actions), function(action) {
        return _c('tr', [_c('td'), _vm._v(" "), _c('td', [_vm._v("\n                                                    " + _vm._s(action.operation.code) + " - " + _vm._s(action.operation.name) + "\n                                                ")])])
      }) : [_c('tr', [_c('td'), _vm._v(" "), _vm._m(6, true)])]]
    })], 2)])])]), _vm._v(" "), _c('div', {}, [_c('h6', [_vm._v("Léčiva")]), _vm._v(" "), _c('div', [(visit.medicament.length > 0) ? [_c('table', {
      staticClass: "table"
    }, [_c('tbody', _vm._l((visit.medicament), function(m) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(m.medicine ? m.medicine.label : '') + "\n                                              " + _vm._s(m.individual_medicine ? m.individual_medicine.name : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(m.dosage))])])
    }))])] : [_c('i', [_vm._v("žádný lék nepředepsán")])]], 2)])])]) : _vm._e()]
  })], 2)])]) : (_vm.visitsPending) ? _c('div', {
    staticClass: "card-body"
  }, [_vm._m(7)]) : _vm._e(), _vm._v(" "), _c('calendar-leisure-time', {
    attrs: {
      "opened": _vm.showModalCalendarLeisureTimeOpened,
      "doctor-id": _vm.doctorId
    },
    on: {
      "leisure-time-updated": _vm.loadCalendar
    }
  }), _vm._v(" "), _c('calendar-working-time', {
    attrs: {
      "opened": _vm.showModalCalendarWorkingTimeOpened,
      "doctor-id": _vm.doctorId
    },
    on: {
      "working-time-updated": _vm.loadCalendar
    }
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th')])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "h4"
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-circle fa-4x",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "h4"
  }, [_vm._v("Musíte zvolit doktora")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Datum / čas"), _c('br'), _vm._v("Klient")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("Důvod návštěvy")]), _vm._v(" "), _c('th')])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('i', [_vm._v("(diagnóza nemá přidělené výkony)")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-3x fa-fw"
  }), _c('br'), _vm._v("\n            (načítám)\n        ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-184a257a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Calendar/components/Calendar.vue
// module id = 447
// module chunks = 0